import type { MemberRole } from '../types/roles';

export function hasFullAccess(role: MemberRole | null, isSuperAdmin: boolean): boolean {
  return isSuperAdmin || role === 'full_access';
}

export function canManageBookings(role: MemberRole | null, isSuperAdmin: boolean): boolean {
  return isSuperAdmin || role === 'full_access' || role === 'booking_only';
}

interface RoleMember {
  user_id: string;
  role: MemberRole;
  active: boolean;
}

export function isLastFullAccessMember<T extends RoleMember>(members: T[], userId: string): boolean {
  const activeFullAccess = members.filter((m) => m.active && m.role === 'full_access');
  return activeFullAccess.length === 1 && activeFullAccess[0].user_id === userId;
}
